var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("UiButton", {
    attrs: {
      variant: _vm.variant,
      buttonText: _vm.buttonText,
      processing: _vm.processing,
      size: _vm.size,
      buttonClasses: _vm.buttonClasses,
    },
    on: { click: _vm.handleClick },
    scopedSlots: _vm._u([
      {
        key: "icon",
        fn: function () {
          return [
            _vm.isWidthraw && _vm.showIcon ? _c("MinusIcon") : _vm._e(),
            !_vm.isWidthraw && _vm.isApply && _vm.showIcon
              ? _c("PlusIcon", { staticClass: "w-4 h-4" })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "hover-icon",
        fn: function () {
          return [
            _vm.isWidthraw && _vm.showIcon ? _c("MinusIcon") : _vm._e(),
            !_vm.isWidthraw && _vm.isApply && _vm.showIcon
              ? _c("PlusIcon", { staticClass: "w-6 h-6" })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }